import { Instrument } from '#/unified-rfqs/entities/drfq/instruments';
import {
  GrfqFutureInstrument,
  GrfqOptionInstrument,
} from '#/unified-rfqs/entities/grfq/domain';
import { OptionKind } from '#/unified-rfqs/entities/shared';

interface DrfqFutureInstrument extends Instrument {
  expiration: number | null;
  kind: 'FUTURE';
  option_kind: null;
}
interface DrfqOptionInstrument extends Instrument {
  expiration: number;
  strike: string;
  kind: 'OPTION';
  option_kind: OptionKind;
}

export interface DrfqInstruments {
  futureInstruments: readonly DrfqFutureInstrument[];
  optionInstruments: readonly DrfqOptionInstrument[];
}

export interface GrfqInstruments {
  futureInstruments: readonly GrfqFutureInstrument[];
  optionInstruments: readonly GrfqOptionInstrument[];
}

export interface UnifiedInstruments {
  futureInstruments: readonly (GrfqFutureInstrument | DrfqFutureInstrument)[];
  optionInstruments: readonly (GrfqOptionInstrument | DrfqOptionInstrument)[];
}

export const INITIAL_INSTRUMENTS_STATE = {
  futureInstruments: [],
  optionInstruments: [],
} as const;
